import {Card, Group, Stack, Text, Title} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

import {DimensionKindBadge} from './Badges';
import {TERM_LABELS} from '../config/labels';
import {PricingDimension} from '../types';

// Read-only. Pricing units are edited in the Edit drawer.
export const PricingUnits = ({dimensions}: { dimensions: PricingDimension[] }) => (
    <Stack>
        <Title order={4}>{I18n.get('Pricing units')}</Title>
        {dimensions.length === 0 && <Text c='dimmed'>{I18n.get('No pricing units')}</Text>}
        {dimensions.map(dimension => (
            <Card key={dimension.dimensionId} withBorder>
                <Stack gap='xs'>
                    <Group justify='space-between'>
                        <Text fw={500}>{dimension.name}</Text>
                        <DimensionKindBadge kind={dimension.kind}/>
                    </Group>
                    <Text size='sm' c='dimmed'>
                        {I18n.get('Unit')}: {dimension.unit}
                    </Text>
                    {dimension.description && <Text size='sm'>{dimension.description}</Text>}
                    {dimension.prices.length === 0 && <Text size='sm' c='dimmed'>—</Text>}
                    {dimension.prices.map((price, index) => (
                        <Group key={index} justify='space-between'>
                            <Text size='sm'>{price.term ? I18n.get(TERM_LABELS[price.term]) : '—'}</Text>
                            <Text size='sm'>{price.currency} {price.amount}</Text>
                        </Group>
                    ))}
                </Stack>
            </Card>
        ))}
    </Stack>
);
